import EventEmitter from "eventemitter3";
//#region src/debug.ts
let FlagCategory = /* @__PURE__ */ function(FlagCategory) {
	FlagCategory[FlagCategory["Renderer"] = 0] = "Renderer";
	FlagCategory[FlagCategory["DebugMessages"] = 1] = "DebugMessages";
	FlagCategory[FlagCategory["Uncategorized"] = 2] = "Uncategorized";
	return FlagCategory;
}({});
var ExperimentFlag = class {
	id;
	enabled;
	category = 2;
	constructor(id, defaultEnabled = false, category) {
		this.id = id;
		this.enabled = defaultEnabled;
		if (category) this.category = category;
	}
};
var FlagManager = class extends EventEmitter {
	flags;
	constructor() {
		super();
		this.flags = [];
		this.register(new ExperimentFlag("PANZOOM_PINCH_TRANSFORM_1", false, 0), new ExperimentFlag("PANZOOM_PINCH_TRANSFORM_2", false, 0), new ExperimentFlag("PANZOOM_PINCH_DEBUG_MESSAGES", false, 1));
	}
	register(...flags) {
		this.flags.push(...flags);
	}
	getFlag(flag) {
		return this.flags.find((f) => f.id === flag);
	}
	enabled(flag) {
		return this.getFlag(flag)?.enabled;
	}
	setEnabled(flagID, enabled) {
		const flag = this.flags.find((f) => f.id === flagID);
		if (!flag) throw new Error("Unknown flag " + flagID);
		flag.enabled = enabled;
		if (enabled) this.emit("enable", flagID);
		else this.emit("disable", flagID);
	}
	getAll() {
		return [...this.flags].sort((a, b) => a.category - b.category);
	}
};
/**
* Debug wrapper
*
* Goals:
* - toggle debug flags (similar to Discord experiments)
* - open blank debug tab with useragent and any flags
*/
var Debugcl = class extends EventEmitter {
	flags = new FlagManager();
	_getRenderer;
	_network;
	/**
	* name -> instance
	*/
	controllers = /* @__PURE__ */ new Map();
	constructor() {
		super();
	}
	openDebug() {
		const wind = window.open("about:blank", "_blank");
		if (!wind) {
			alert("Failed to open debug tab. Is your anti-popup too powerful? Or did this get triggered from not a trusted event");
			return;
		}
		wind.document.write(`
    <h1>debug menu</h1>
    <pre>${JSON.stringify({
			userAgent: navigator.userAgent,
			flags: this.flags.getAll().filter((f) => f.enabled).map((f) => f.id)
		}, null, 2)}</pre>
    `);
		wind.document.close();
	}
	openDebugTools() {
		this.emit("openTools");
	}
	/**
	* Create debug marker
	*
	* Useful on touchscreen devices
	*
	* @param type
	* @param args
	* @returns
	*/
	debug(type, ...args) {
		switch (type) {
			case "point": {
				const [x, y, id] = args;
				if (document.getElementById("debug-" + id)) {
					document.getElementById("debug-" + id).style.top = y + "px";
					document.getElementById("debug-" + id).style.left = x + "px";
					return;
				}
				const el = document.createElement("div");
				if (id) el.id = "debug-" + id;
				el.classList.add("debug-point");
				el.style.setProperty("top", y + "px");
				el.style.setProperty("left", x + "px");
				document.body.appendChild(el);
				break;
			}
			case "text": {
				const [str] = args;
				if (!document.getElementById("canvas-meta-debug")) {
					const debugBox = document.createElement("div");
					debugBox.id = "canvas-meta-debug";
					debugBox.style.whiteSpace = "pre";
					debugBox.style.unicodeBidi = "embed";
					document.getElementById("canvas-meta").prepend(debugBox);
				}
				document.getElementById("canvas-meta-debug").innerText = typeof str === "string" ? str : JSON.stringify(str, null, 2);
				break;
			}
		}
	}
	getRenderer() {
		return this._getRenderer();
	}
	getNetwork() {
		return this._network;
	}
};
const Debug = new Debugcl();
window.Debug = Debug;
//#endregion
export { Debug, FlagCategory };

//# sourceMappingURL=debug.mjs.map